import React, {Component} from 'react';
import {Row, Col, Form, Label, Container, Button } from "reactstrap";
import SearchField from "../../../comum/components/SearchField";
import InputFiltro from '../../../comum/components/InputFiltro';
import SelectFiltro from "../../../comum/components/SelectFiltro";
import Card from '../../../comum/components/Card';

export default class FiltrosContainers extends Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;

        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleSubmit(e){
        e.preventDefault()
        this.controller.listar(e)
    }

    render() {
        let camposXl = 3;

        return(
            <Card>
                <div className="filtros">
                    <Form onSubmit={this.handleSubmit}>
                        <Row className="align-items-end">

                            <InputFiltro titulo="Cód. Container"  xl={camposXl} sm={6} xs={12}
                                uppercase = {true}
                                onChange = {e => this.controller.adicionarFiltro("Cntr",e.target.value)}
                                />

                            <InputFiltro titulo="Nº Booking"  xl={camposXl} sm={6} xs={12}
                                uppercase = {true}
                                onChange = {e => this.controller.adicionarFiltro("BookingNbr",e.target.value)}
                                />

                            <InputFiltro titulo="Nº Nota Fiscal"  xl={camposXl} sm={6} xs={12}
                                uppercase = {true}
                                onChange = {e => this.controller.adicionarFiltro("NotaFiscalTranspNum",e.target.value)}
                            />


                            <Col xl={camposXl} sm={6} xs={12} className="mb-4 justify-content-start align-bottom">
                                <Button className="btn-com-bordas-primary btn-filtrar">Filtrar</Button>
                            </Col>

                        </Row>
                    </Form>
                </div>
            </Card>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/consultas/containers/components/FiltrosContainers.js